import { Trans } from "@lingui/macro";
import { IApiEpBillingProductPlanProduct, IPeriodUnit } from "@smp/api";
import { UiBox, UiTypography } from "@smp/ui";
import { textCurrencySymbolGet } from "@smp/utils";

import { useHumanizer } from "@/hooks/use_humanizer";

import { useContextDialogPurchase } from "../../../../context";

export const PlanProductAdditions = ({
  productPlanProduct,
}: {
  productPlanProduct: IApiEpBillingProductPlanProduct;
}) => {
  const {
    state: { paymentTypeSelected },
  } = useContextDialogPurchase();

  const { humanizeBillingPlanId, humanizePeriodUnit } = useHumanizer();

  const period =
    productPlanProduct.period_units === IPeriodUnit.DAY &&
    productPlanProduct.period_length === 1
      ? humanizePeriodUnit(
          IPeriodUnit.HOUR,
          productPlanProduct.period_length * 24,
        )
      : humanizePeriodUnit(
          productPlanProduct.period_units,
          productPlanProduct.period_length,
        );

  return (
    <UiBox mb={2}>
      <UiTypography color="textSecondary" variant="subtitle2">
        {paymentTypeSelected === "recurring" && (
          <Trans>
            The {humanizeBillingPlanId(productPlanProduct.plan.id)} Plan
            subscription will be activated for {period}
            .
            <br />
            Total payment: {productPlanProduct.price}{" "}
            {textCurrencySymbolGet(productPlanProduct.currency)}.
          </Trans>
        )}
        {paymentTypeSelected === "single" && (
          <Trans>
            The {humanizeBillingPlanId(productPlanProduct.plan.id)} Plan will be
            activated for {period}
            .
            <br />
            Total payment: {productPlanProduct.price}{" "}
            {textCurrencySymbolGet(productPlanProduct.currency)}.
          </Trans>
        )}
      </UiTypography>
    </UiBox>
  );
};
